import { useEffect, useState } from 'react'
import AgeCard from '../ageCard'
import styles from './index.module.less'
import { useRequest } from 'ahooks'
import { IResAgePledgeListItem } from '@/api/account/interface'
import { getAgePledgeList } from '@/api/account'
import MeEmpty from '@/components/MeEmpty'
import LoadingCom from '@/components/LoadingCom'

interface IProps {
  address: string
  activeValue: string | undefined
  pageParams: {
    page: number
    limit: number
  }
  setAgeTotal: (total: number) => void
  setAgeLoading: (loading: boolean) => void,
}
const AgeList = ({address, activeValue, pageParams, setAgeTotal, setAgeLoading }:IProps) => {
  const listParams = {
    address,
    page_number: pageParams.page,
    page_size: pageParams.limit,
  }
  const [ageList, setAgeList] = useState<IResAgePledgeListItem[]>([])
  const { loading, run } = useRequest(() => getAgePledgeList(listParams), {
    manual: true,
    onSuccess: (res) => {
      setAgeList(res?.ageDelegation || [])
      setAgeTotal(res?.total || 0)
    },
  })

  useEffect(() => {
    run()
  },[pageParams, run, address])

  useEffect(() => {
    setAgeLoading(loading)
  },[loading, setAgeLoading])

  return (
    <>
      {activeValue === '2' && (
        <div className={styles.wrap}>
          { loading && <LoadingCom /> }
          { !loading && ageList.length === 0 && <MeEmpty /> }
          { ageList.map((item, index) => <AgeCard {...item} key={`ageList${index}`} />) }
        </div>
      )}
    </>
  )
}

export default AgeList
